// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBar_search__1PZkv","active":"SearchBar_active__2klRk","icon":"SearchBar_icon__32-k8","input":"SearchBar_input__39eT_","clear":"SearchBar_clear__DIsOI"};